// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['react', '/www/hola/pub/context.js',
    '/www/hola/pub/util.js', '/www/hola/pub/config.js', '/util/util.js',
    'hola_opt', '/util/string.js', 'classnames', '/www/hola/pub/be.js',
    '/util/url.js', '/util/etask.js', '/util/version_util.js',
    'svc_versions', '/util/escape.js', 'react-router-dom',
    '/www/hola/pub/404.js', '/www/hola/pub/img/svg/icon/ic_slope.svg',
    '/www/hola/pub/shared/svg', '/svc/vpn/pub/util.js',
    // import only
    '/www/hola/pub/css/unblock_my_settings.less',
    '/www/hola/pub/css/wbm_flags.less'],
    (React, context, www_util, config, zutil, hopt, string, cn, be,
    zurl, etask, version_util, hola_versions, zescape, RRD, not_found,
    Icon_slope, {Svg}, svc_util)=>
{
var E = {};
const {App_context} = context;
const {useLocation} = RRD;
const {useEffect, useContext, useState} = React;

const Settings_header = props=>{
    const {info} = props;
    // product_info() drops appid, take it from the raw svc info
    const latest = svc_util.pick_version(hola_versions,
        svc_util.get_product(be.svc()?.appid), 'windows');
    const show_update = info.svc_version &&
      version_util.cmp(info.svc_version, latest)<0;
    const update_href = `/download?cid=${info.cid}&upgrade=1`;
    const update_cls = 'update-available btn btn-primary btn-xs';
    return <div className="page_header container-fluid">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 settings-header">
            {show_update && <a href={update_href} className={update_cls}>
              Update is available</a>}
          </div>
        </div>
      </div>
    </div>;
};

const About_header = props=>{
    const {info} = props;
    const show_report = !be.is_android();
    const to = be.is_android() ? 'help_android@hola.org' : 'help_be@hola.org';
    const report_href = zescape.mailto_url({to,
        subject: 'Problem with Hola (my settings)',
        body: '(Please include a brief explanation of the problem and '
        +'a screenshot if possible)\n\n'
        +'Information automatically generated about my problem:\n'
        +be.print_product_info(document.createElement('div'), info)});
    const on_report = ev=>{
        be.perr({id: 'www_report_problem', info: 'my_settings'});
        if (be.is_chrome())
            return;
        ev.preventDefault();
        window.open(report_href, '_blank', 'resizable');
    };
    return <div className="row list-header about_header">
      <div className="col-xs-7 headline">
        <h4>About this version</h4>
      </div>
      <div className="col-xs-5 actions">
        {show_report && <div className="report-problem">
          <span>Report a problem - </span>
          <a href={report_href} onClick={on_report}>{to}</a>
        </div>}
      </div>
    </div>;
};

const remove_rule = rule=>etask(function*(){
    this.on('uncaught', e=>{
        be.perr({id: 'www_rule_unset_err', bt: e.stack,
            info: 'sid '+rule.sid+' name '+rule.name+' '+e});
    });
    yield be.rule_set(rule, 0, {del: 1});
    yield be.fetch_all();
});
const toggle_rule = (rule, active)=>etask(function*(){
    this.on('uncaught', e=>{
        be.perr({id: 'www_rule_set_err', bt: e.stack,
            info: 'sid '+rule.sid+' name '+rule.name+' '+e});
    });
    yield be.rule_set(rule, active);
    yield be.fetch_all();
});
const Rule = props=>{
    const {rule, id, add_undo} = props;
    const {enabled, name, link, country} = rule;
    const [active, set_active] = useState(enabled);
    const on = active && props.enabled;
    const domain = zurl.get_host(zurl.add_proto(link||'')+'/')||name;
    const href = `http://${domain}`;
    const cls = cn('rule dynamic entry', {active: on});
    const switch_cls = cn('rule-switch checkbox', {checked: on});
    const on_toggle = ()=>set_active(v=>!v);
    const on_remove = ()=>{
        remove_rule(rule);
        add_undo(rule);
    };
    useEffect(()=>{
        etask(function*(){
            if (active == enabled)
                return;
            if (active)
                yield be.enable_unblocker(true);
            yield toggle_rule(rule, active);
        });
    }, [active]);
    return <li className={cls} data-id={id}>
      <div className="rule_item rule-switch-wrap" onClick={on_toggle}>
        <span className={switch_cls} data-original-title="" title=""/>
        <div className="tooltip fade top in" role="tooltip">
          <div className="tooltip-arrow" style={{left: '50%'}}/>
          <div className="tooltip-inner">Turn {on ? 'off' : 'on'}</div>
        </div>
      </div>
      <div className="rule_item rule-country-wrap">
        <span className="f32">
          <i className={`flag ${country}`}/>
        </span>
      </div>
      <div className="rule_item rule-url-wrap">
        <a className="rule-url" href={href}
          target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      </div>
      <div className="rule_item rule-remove-wrap" onClick={on_remove}>
        <span className="rule-remove" data-original-title="" title="Delete"/>
      </div>
    </li>;
};

const Vpn_rule_list = props=>{
    const {rules, add_undo} = props;
    const [enabled, set_enabled] = useState(be.get('enabled'));
    const keys = Object.keys(rules);
    useEffect(()=>{
        const cb = ()=>set_enabled(be.get('enabled'));
        be.on('change:svc.info change:ext.info', cb);
        be.fetch_rules();
    }, []);
    return <ul>
      {keys.map(k=><Rule key={k} id={k} rule={rules[k]}
        enabled={enabled} add_undo={add_undo}/>)}
      {!keys.length && <li className="rule entry empty_entry">
        <div className="message">
          <span className="text">
            You have not selected any site to unblock.
          </span>
          <a href="/access/popular" className="link"> Click to find sites</a>
        </div>
      </li>}
    </ul>;
};

const Product_info = props=>{
    const {info = be.product_info(), dev} = props;
    let {ext_version, server_version, svc_version, svc_mode, product_type,
        browser2, browser, platform, cid, uuid, svc_mode_pending} = info;
    if (!ext_version)
        ext_version = window.zon_config && window.zon_config.ZON_VERSION;
    let mode;
    if (svc_mode)
    {
        mode = `${svc_mode} active${svc_mode_pending ?
            ', '+svc_mode_pending+' pending' : ''}`;
    }
    cid = be.be_bg_main && be.be_bg_main.get('svc.cid') || cid;
    uuid = be.be_bg_main && be.be_bg_main.get('uuid') || uuid;
    return <div className="panel panel-default product_info">
      <div className="panel-body">
        {ext_version && <div>
          <span>Ext version: </span><span>{ext_version}</span>
        </div>}
        {server_version && <div>
          <span>WWW version: </span><span>{server_version}</span>
        </div>}
        {svc_version && <div className="product-service-version">
          <span>Service: </span><span>{svc_version}</span>
        </div>}
        {svc_mode && <div>
          <span>Mode: </span><span>{mode}</span>
        </div>}
        {product_type && <div>
          <span>Product: </span><span>{product_type}</span>
        </div>}
        {(browser2 || browser) && <div>
          <span>Browser: </span><span>{browser2 || browser}</span>
        </div>}
        {platform && <div>
          <span>Platform: </span><span>{platform}</span>
        </div>}
        {cid && <div>
          <span>CID: </span><span>{cid}</span>
        </div>}
        {uuid && <div>
          <span>UUID: </span><span>{uuid}</span>
        </div>}
        {dev && <div>
          <span>Dev info: </span><span>{dev}</span>
        </div>}
      </div>
    </div>;
};

const Settings_hr = ()=><div className="settings-hr"></div>;

const Settings_p = props=><div className="settings-p">{props.children}</div>;

const Subscribe_plus_btn = ()=><a className="subscribe-plus-btn"
  href="/plus?ref=p2p_settings">
  <span>Subscribe to PLUS $2.99/mo</span>
</a>;

// XXX sergeir: always true, need to make it switchable when needed
class Settings_switch extends React.Component {
    on_click = ()=>{
        this.props.on_change();
    };
    render(){
        return <div className="settings-switch" onClick={this.on_click}>
          <div className="info">
            <div className="title">{this.props.title}</div>
            <div className="subtitle">{this.props.subtitle}</div>
          </div>
          <div className="switch"></div>
        </div>;
    }
}

class P2p_settings_tab extends React.Component {
    state = {};
    promote_plus = ()=>{
        this.setState({promote_plus: true});
    };
    render(){
        return <div>
          <Settings_switch title={'Allow to be a peer'}
            subtitle={'Share minimal resources'}
            on_change={this.promote_plus}/>
            {this.state.promote_plus &&
          <Settings_p>
            If you don't want to be a peer, subscribe to PLUS
            <Subscribe_plus_btn/>
          </Settings_p>}
          <Settings_hr/>
          <Settings_p>
            <a href="https://support.hola.org/en/collections/9935345-faq">About the hola P2P Network</a>
          </Settings_p>
        </div>;
    }
}

const Svg_slope = ()=>{
    return <Svg icon={<Icon_slope width={20} height={36}/>} cls="tabs-side"/>;
};
const software_attribution_url = '/software_attribution?ref=unblock&amp;'
    +'utm_source=settings';
const get_rules = ()=>be.get('rules')||{};
const get_info = ()=>be.product_info();
const Root = function Access_my_settings(props){
    if (props.internal_err)
        return <not_found.Root {...props}/>;
    const {user, is_plus} = useContext(App_context);
    const {user_country} = props;
    const {hash, pathname} = useLocation();
    const [tab, set_tab] = useState((hash.match(/^#\/?(.*)/)||[])[1]||
        'vpn');
    const [rules, set_rules] = useState(get_rules());
    const [info, set_info] = useState(get_info());
    const [undo, set_undo] = useState({});
    const [is_svc, set_is_svc] = useState(be.is_svc());
    const undo_length = Object.keys(undo).length;
    const add_undo = rule=>{
        if (undo[rule.id])
            return;
        const fn = ()=>etask(function*(){
            yield toggle_rule(rule, rule.enabled);
        });
        set_undo(v=>({...v, [rule.id]: fn}));
    };
    const on_undo = ()=>{
        Object.keys(undo).forEach(k=>etask(function*(){
            yield undo[k]();
            set_undo(v=>{
                delete v[k];
                return v;
            });
        }));
    };
    const on_clear_all = ()=>{
        Object.keys(rules).forEach(k=>etask(function*(){
            const rule = rules[k];
            yield remove_rule(rule);
            add_undo(rule);
        }));
    };
    useEffect(()=>{
        www_util.perr_www_visit({id: 'www_access_my_settings_visit', user});
        be.init({src_country: user_country});
        be.on('change:rules', ()=>set_rules(get_rules()));
        be.on('change:svc.info change:ext.info', ()=>{
            set_info(get_info());
            set_is_svc(be.is_svc());
        });
        be.on('change:svc.info change:ext.info change:browser', ()=>{});
        be.init_fetch_rules();
        document.documentElement.classList.add('my_settings');
        return ()=>{
          document.documentElement.classList.remove('my_settings');
        };
    }, []);
    const on_tab_click = label=>()=>{
        set_tab(label);
        history.replaceState(null, null, `${pathname}#/${label}`);
    };
    const vpn_tab_cls = cn('tabs-button', {'tabs-active': tab=='vpn'});
    const about_tab_cls = cn('tabs-button', {'tabs-active': tab=='about'});
    const p2p_tab_cls = cn('tabs-button', {
        hidden: !is_svc || is_plus,
        'tabs-active': tab=='p2p',
    });
    const vpn_cls = cn('col-xs-12 tab-content', {'tabs-active': tab=='vpn'});
    const about_cls = cn('col-xs-12 tab-content', {
        'tabs-active': tab=='about',
    });
    const p2p_cls = cn('col-xs-12 tab-content', {'tabs-active': tab=='p2p'});
    const undo_cls = cn('vpn-undo', {'undo-hidden': !undo_length});
    const undo_title = 'Undo remove '+(undo_length==1 ? 'one rule' :
        `${undo_length} rules`);
    return <div className="unblock-settings_new"><div className="wrap">
      <Settings_header {...props} info={info}/>
      <div className="container rules">
        <div className="tabs-row row">
          <span className={vpn_tab_cls} data-label="vpn"
            onClick={on_tab_click('vpn')}>
            <Svg_slope/>
            <span className="tabs-icon vpn-icon"></span>
            <span className="tabs-label">Hola</span>
            <Svg_slope/>
          </span>
          <span className={p2p_tab_cls} data-label="p2p"
            onClick={on_tab_click('p2p')}>
            <Svg_slope/>
            <span className="tabs-icon p2p-icon"></span>
            <span className="tabs-label">P2P</span>
            <Svg_slope/>
          </span>
          <span className={about_tab_cls} data-label="about"
            onClick={on_tab_click('about')}>
            <Svg_slope/>
            <span className="tabs-icon about-icon"></span>
            <span className="tabs-label">About</span>
            <Svg_slope/>
          </span>
        </div>
      </div>
      <div className="container activate-hola-wrap">
        <div className="msg_install_anchor row"></div>
      </div>
      <div className="msg_error_anchor container"></div>
      <div className="container main-container">
        <div className="row tabs-container">
          <div data-label="vpn" className={vpn_cls}>
            <div className="row">
              <div className="col-xs-12">
                <div className="my-scripts-anchor"></div>
              </div>
              <div className="col-xs-12 list-header-wrap">
                <div className="row list-header rules_list_header">
                  <div className="col-xs-11 headline">
                    <h4>Recently visited sites</h4>
                  </div>
                  <div className="col-xs-1 actions">
                    <span className="vpn-clear-all-data" title="Clear all"
                      onClick={on_clear_all}/>
                    <span className={undo_cls} title={undo_title}
                      onClick={on_undo}/>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 table-wrap">
                <Vpn_rule_list rules={rules} add_undo={add_undo}/>
              </div>
            </div>
          </div>
          <div data-label="p2p" className={p2p_cls}>
            <div className="row">
              <div className="col-xs-12">
                <div className="col-xs-12 list-header-wrap">
                  <div className="row list-header settings_header">
                    <div className="col-xs-12 headline">
                      <h4>P2P settings</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 p2p-wrap">
                {is_svc && !is_plus && <P2p_settings_tab/>}
              </div>
            </div>
          </div>
          <div data-label="about" className={about_cls}>
            <div className="row">
              <div className="col-xs-12">
                <div className="col-xs-12 list-header-wrap">
                  <About_header info={info}/>
                </div>
              </div>
              <div className="col-xs-12 table-wrap">
                <Product_info info={info}/>
                <a href={software_attribution_url}>Creative licenses</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div></div>;
};

E = {Root};

return E;
});
